import * as React from "react";

const columns = (t) => [
    {
        field: "machineType",
        label: t ? t("common.machine_type") : "Typ maszyny",
        sort: "desc",
        width: 53,
        type: "enum",
        enumType: "enums/machineType",
    },
    {
        label: t ? t("common.model") : "Model",
        field: "model",
        sort: "desc",
        width: 53,
    },
    {
        label: t ? t("common.serial_number") : "Numer seryjny",
        field: "serialNumber",
        sort: "desc",
        width: 53,
    },
];

export default columns;